import { LocalizationStore } from "./LocalizationStore";
/**
 * @deprecated use `useLocalNum` instead
 */ export function localNum(value, opts) {
    if (value === undefined) {
        return undefined;
    }
    return Intl.NumberFormat(LocalizationStore.get().currencyFormatLocale, opts).format(value);
}
